<template>
  <main class="v2-site">
    <header class="v2-nav">
      <a href="#v2-top" class="v2-brand">
        <img src="@/assets/transSave/resource/image/5e/ee/5e1be909bac86b0bdde9c0805ce1acee.png" alt="深圳大学、微众银行" />
      </a>
      <nav>
        <a href="#v2-about">{{ isEnLang ? 'About' : '大赛介绍' }}</a>
        <a href="#v2-tracks">{{ isEnLang ? 'Tracks' : '赛题说明' }}</a>
        <a href="#v2-schedule">{{ isEnLang ? 'Schedule' : '大赛日程' }}</a>
        <a href="#v2-awards">{{ isEnLang ? 'Awards' : '大赛亮点' }}</a>
      </nav>
      <div class="v2-actions">
        <button class="v2-register" @click="openRegistration">{{ isEnLang ? 'Register' : '立即报名' }}</button>
        <div class="v2-lang">
          <button :class="{ active: !isEnLang }" @click="setLanguage('zh-CN')">中</button>
          <i></i>
          <button :class="{ active: isEnLang }" @click="setLanguage('en-US')">EN</button>
        </div>
      </div>
    </header>

    <section id="v2-top" class="v2-hero">
      <img :src="heroImage" :alt="isEnLang ? '2026 Shenzhen International FinTech Competition — WeBank FinTech College Students Challenge' : '2026深圳国际金融科技大赛——微众银行金融科技大学生挑战赛'" />
      <div class="v2-hero-bar">
        <div class="v2-hero-meta">
          <span><b>03</b>{{ isEnLang ? 'Competition Tracks' : '竞赛赛道' }}</span>
          <span><b>750K</b>{{ isEnLang ? 'RMB Prize Pool' : '人民币奖金池' }}</span>
          <span><b>GLOBAL</b>{{ isEnLang ? 'APEC Recruitment' : '面向 APEC 高校招募' }}</span>
        </div>
        <button class="v2-hero-cta" @click="openRegistration">
          {{ isEnLang ? 'Register now' : '立即报名' }} <i>↗</i>
        </button>
      </div>
    </section>

    <section id="v2-about" class="v2-about v2-section">
      <div class="v2-kicker">01 / INTRODUCTION</div>
      <div class="v2-about-grid">
        <div>
          <h2>{{ isEnLang ? 'Competition Introduction' : '大赛介绍' }}</h2>
          <div class="v2-stats">
            <span><b>8</b>{{ isEnLang ? 'Editions' : '连续举办八年' }}</span>
            <span><b>10K+</b>{{ isEnLang ? 'Students' : '海内外高校学子' }}</span>
            <span><b>1,000+</b>{{ isEnLang ? 'Projects' : '金融科技作品' }}</span>
          </div>
        </div>
        <div class="v2-about-copy">
          <p v-for="(paragraph, index) in home.introduction.intro" :key="index" v-html="paragraph"></p>
        </div>
      </div>
    </section>

    <section id="v2-tracks" class="v2-tracks v2-section">
      <div class="v2-section-head">
        <div class="v2-kicker">02 / TRACKS</div>
        <h2>{{ isEnLang ? 'Competition Tracks' : '赛题说明' }}</h2>
        <p>{{ isEnLang ? 'Domestic Artificial Intelligence, International Artificial Intelligence and Data Analytics.' : '人工智能赛道（国内）、人工智能赛道（国际）与数据分析赛道。' }}</p>
      </div>
      <div class="v2-track-grid">
        <article v-for="(track, index) in trackCards" :key="track.key" :class="{ featured: track.key === 'international-ai' }">
          <header><span>0{{ index + 1 }}</span><small>{{ track.region }}</small></header>
          <h3>{{ track.title }}</h3>
          <h4>{{ track.subtitle }}</h4>
          <p>{{ track.summary }}</p>
          <button @click="openRegistration">{{ isEnLang ? 'Explore track' : '了解赛道' }} <i>↗</i></button>
        </article>
      </div>
    </section>

    <section id="v2-schedule" class="v2-schedule v2-section">
      <div class="v2-section-head light">
        <div class="v2-kicker">03 / SCHEDULE</div>
        <h2>{{ isEnLang ? 'Competition Schedule' : '大赛日程' }}</h2>
      </div>
      <div class="v2-common">
        <div v-for="event in home.schedule.common" :key="event.date"><b>{{ event.date }}</b><span>{{ event.title }}</span></div>
      </div>
      <div class="v2-schedule-tabs">
        <button :class="{active: scheduleRegion === 'domestic'}" @click="scheduleRegion='domestic'">{{ isEnLang ? 'DOMESTIC' : '国内赛道' }}</button>
        <button :class="{active: scheduleRegion === 'international'}" @click="scheduleRegion='international'">{{ isEnLang ? 'INTERNATIONAL' : '国际赛道' }}</button>
      </div>
      <div class="v2-roadmap">
        <article v-for="track in visibleScheduleTracks" :key="track.key">
          <h3>{{ track.label }}</h3>
          <ol>
            <li v-for="(event, index) in track.events" :key="event.date">
              <i>{{ String(index + 1).padStart(2, '0') }}</i>
              <b>{{ event.date }}</b>
              <span>{{ event.title }}</span>
            </li>
          </ol>
        </article>
        <aside>
          <small>FINALE · SHENZHEN</small>
          <b>{{ home.schedule.finale.date }}</b>
          <strong>{{ home.schedule.finale.title }}</strong>
          <span>{{ home.schedule.finale.place }}</span>
        </aside>
      </div>
    </section>

    <section id="v2-awards" class="v2-awards v2-section">
      <div class="v2-award-main">
        <div class="v2-kicker">04 / AWARDS</div>
        <span>{{ isEnLang ? 'TOTAL PRIZE POOL' : '总奖金池' }}</span>
        <h2>¥750,000</h2>
        <p>{{ home.prize.highlights.note }}</p>
      </div>
      <div class="v2-award-list">
        <div v-for="award in home.prize.highlights.awards" :key="award.rank">
          <span>{{ award.rank }}</span><b>{{ award.amount }}</b>
        </div>
      </div>
    </section>

    <section class="v2-partners v2-section">
      <div class="v2-section-head">
        <div class="v2-kicker">05 / PARTNERS</div>
        <h2>{{ isEnLang ? 'Partners' : '合作单位' }}</h2>
      </div>
      <div class="v2-logo-row">
        <img src="@/assets/img/ican-logo.png" alt="iCAN" />
        <img src="@/assets/img/tsinghua-fintech-institute.png" alt="Tsinghua Institute of Financial Technology" />
        <img src="@/assets/img/ieee-cis-singapore.png" alt="IEEE CIS Singapore Chapter" />
      </div>
      <div class="v2-units">
        <div v-for="group in home.partners" :key="group.title"><b>{{ group.title }}</b><p>{{ group.list.join('　·　') }}</p></div>
      </div>
    </section>

    <footer>
      <span>FINTECHATHON 2026</span>
      <p>SHENZHEN INTERNATIONAL FINTECH COMPETITION</p>
      <button @click="switchToV1">{{ isEnLang ? 'View original design V1' : '查看原版设计 V1' }}</button>
    </footer>
  </main>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import * as GlobalLayer from '@/utils/globalLayer'

export default {
  props: ['home'],
  data: () => ({ scheduleRegion: 'domestic' }),
  computed: {
    ...mapState(['isEnLang']),
    heroImage () {
      return this.isEnLang
        ? require('@/assets/img/banner-2026-en-v2.jpg')
        : require('@/assets/img/banner-2026-zh-v2.jpg')
    },
    trackCards () {
      const notes = this.home.note
      const find = region => notes.find(item => item.region === region)
      const domesticAi = notes.find(item => item.region === 'domestic' && item.type === 'ai')
      const data = notes.find(item => item.region === 'domestic' && item.type !== 'ai')
      const international = find('international')
      return [
        { key: 'domestic-ai', region: this.isEnLang ? 'DOMESTIC' : '国内赛道', title: this.isEnLang ? 'Artificial Intelligence' : '人工智能', subtitle: domesticAi.introTitle, summary: this.plain(domesticAi.intro) },
        { key: 'international-ai', region: this.isEnLang ? 'INTERNATIONAL' : '国际赛道', title: this.isEnLang ? 'Artificial Intelligence' : '人工智能', subtitle: international.introTitle, summary: this.plain(international.intro) },
        { key: 'data', region: this.isEnLang ? 'DOMESTIC' : '国内赛道', title: this.isEnLang ? 'Data Analytics' : '数据分析', subtitle: this.isEnLang ? 'Five real-world fintech challenges' : '五道真实金融科技赛题', summary: this.plain(data.subtitle || data.intro) }
      ]
    },
    visibleScheduleTracks () {
      return this.home.schedule.tracks.filter(track => this.scheduleRegion === 'international' ? track.key === 'international-ai' : track.key !== 'international-ai')
    }
  },
  methods: {
    ...mapActions(['setLang']),
    plain (html) { return String(html || '').replace(/<[^>]+>/g, '').slice(0, 150) },
    openRegistration () {
      GlobalLayer.createModal(this.$store, { detailsText: { title: this.isEnLang ? 'Coming soon' : '敬请期待' }, isShowBtn: true, compact: true })
    },
    setLanguage (lang) {
      const primary = this.$route.meta.primaryName || this.$route.name.replace(/En$/, '')
      const name = lang === 'en-US' ? `${primary}En` : primary
      this.setLang(lang).then(() => this.$router.push({ name, query: this.$route.query }))
    },
    switchToV1 () { this.$router.replace({ query: { ...this.$route.query, design: 'v1' } }) }
  }
}
</script>

<style lang="scss" scoped>
@import './v2-home.scss';
</style>
